import { FieldDefinition } from "../../../../component/form/field-definition";
import { individualGenderOptions } from "../../../../utils/form-select-input-options";

export const applicantFieldDefinitions: FieldDefinition[] = [
    {
        id: "name",
        name: "Name",
        type: "text",
        required: true,
        disabled: false
    },
    {
        id: "phone",
        name: "Phone",
        type: "phone",
        required: false,
        disabled: false
    },
    {
        id: "email",
        name: "Email",
        type: "email",
        required: true,
        disabled: false
    },
    {
        id: "gender",
        name: "Gender",
        type: "select",
        required: false,
        disabled: false,
        values: individualGenderOptions()
    },
    {
        id: "active",
        name: "Active",
        type: "boolean",
        required: true,
        disabled: false
    }
];